import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(stream_type => ({
        value: stream_type.id,
        label: stream_type.type,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/stream_type', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
